import { IReportPreviewResponse, IStandardApiResponse } from "src/pages/Studies/models/interfaces";
import { IinsightsButtonStatusObj } from "../models/interfaces";
import { apiService } from "../../../services";
import { IfileDetails } from "../models/interfaces";

export const getDescriptionGuideDetails = async (file_id: number | string, study_id: string, is_edit_mode: boolean) => {
	return await apiService.get<IStandardApiResponse<Record<string, unknown>>>("/dg/", { file_id, study_id, is_edit_mode });
};

export const saveDescriptionGuideDetails = async (DGDetails: any) => {
	return await apiService.post("/dg/", DGDetails);
};

export const getStudyDetails = async (study_id: string) => {
	return await apiService.get("/entities/", { study_id });
};

export const releaseLockDG = async (details: { study_id: string; file_id: string }) => {
	return await apiService.post("/dg/release-lock", details);
};

export const releaseLockTranscript = async (details: { study_id: string; file_id: string }) => {
	return await apiService.post("/transcripts/release-lock", details);
};

export const getTranscriptDetails = async (study_id: string, file_id: string, is_edit_mode: boolean, lang_code?: string) => {
	return await apiService.get("/transcripts/", { study_id, file_id, is_edit_mode, lang_code });
};

export const updateTranscriptDetails = async (transcriptDetails) => {
	return await apiService.put(`/transcripts/edit`, transcriptDetails);
};

export const previewReport = async (details: { study_id: string; file_id: string }): Promise<IReportPreviewResponse> => {
	return await apiService.get<IReportPreviewResponse>("/report/", details);
};

export const DeleteTranscriptDetails = async (transcriptId: string) => {
	return await apiService.delete(`/transcript/${transcriptId}`);
};

export const reverseTranscriptToOriginal = async (Details: { study_id: string; document_id: string; document_type: string; file_id: string }) => {
	return await apiService.post("/files/revert", Details);
};

export const getInsightStatus = async (study_id: string) => {
	const response = await apiService.get<IStandardApiResponse<{ data: IinsightsButtonStatusObj }>>(
		"/insights/insight-generation-status",
		{ study_id },
	);
	return { ...response, data: response.data?.data };
};

export const generateInsights = async (study_id: string) => {
	return await apiService.get("/insights/generate", { study_id });
};

export const updateFileStatus = async (fileDetails) => {
	return await apiService.post("/files/upload_status", fileDetails);
};

export const autoGenerateDG = async (study_type_name: string, study_id: string, file_type: string, file_details: IfileDetails[]) => {
	return await apiService.post("/files/auto-dg", { study_type_name, study_id, file_type, file_details });
};

export const linkTaxonomy = async (values: any) => {
	return await apiService.post("/entities/taxonomy/link", { ...values });
};

export const getViewNotes = async (study_id: string, file_id: string, page: number, page_size: number, search?: string) => {
	return await apiService.get("/notes/view", { study_id, file_id, page, page_size, search });
};

export const resetQuantStudyCache = async (values) => {
	return await apiService.delete("/quant/reset_cache", values);
};
